// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z_i2","title":"styles_title__2Mf8y"};